module.exports = __webpack_public_path__ + "assets/img/llh_b2.605cfa60.jpg";